module.exports = __webpack_public_path__ + "img/loading.70d94ccd.gif";